module.exports = __webpack_public_path__ + "static/img/noArea.8f0ecca2.png";